export enum CepPaginationMode {
  Questionnaire = 'Questionnaire',
  QuestionGroup = 'QuestionGroup',
}
